// Polis, l'onglet Scénarios (16 octobre 2026) : les candidatures possibles et leurs scénarios.
export default {
  chargement: 'Chargement…',
  erreur: 'Les scénarios n’ont pas pu se lire.',
  reessayer: 'Réessayer',
  titre: 'Les candidatures et leurs scénarios',
  texte: 'Qui pourrait encore se déclarer, avec quelle probabilité, et ce que chaque combinaison de candidatures donnerait au premier tour.',
  dernierPoint: 'Dernier point sur les candidatures le {jour} ; il se refait chaque lundi.',
  refaire: 'Refaire le point maintenant',
  refaitEnCours: 'Le point se refait : quelques minutes.',
  pct: '{n} %',
  fourchette: '{bas} ~ {haut}',
  probabiliteAria: '{nom} : {p} % de chances de se déclarer',
  exclusif: 'Une seule candidature avec : {noms}',
  voirDetail: 'Voir le détail',
  masquer: 'Masquer',
  possibles: {
    titre: 'Les candidatures possibles',
    legende: 'la probabilité de se déclarer, et ce qui la fonde',
    aucune: 'Aucune candidature possible relevée : tous les candidats suivis sont déclarés.',
  },
  prediction: {
    titre: 'La prédiction d’Orion',
    selonJumeaux: 'selon la projection des jumeaux, les sondages en repère',
    selonSondages: 'selon la projection des sondages : les notes des jumeaux viendront avec la prochaine vague',
    sondages: 'sondages {p}',
    premierTour: 'Le premier tour',
    secondTour: 'Le second tour le plus probable',
    vainqueur: 'Le vainqueur',
    chanceDuel: '{p} des cas',
    contre: 'contre {p} à {nom}',
    duelAMesurer: 'Ce duel se mesurera à la prochaine vague.',
    vainqueurAMesurer: 'Le vainqueur se prédira quand une vague aura mesuré les seconds tours.',
    nonMesure: 'seconds tours non mesurés : {p}',
  },
  secondTour: {
    titre: 'Le second tour',
    legende: 'chaque duel probable, la part des scénarios où il a lieu, et ce qu’y feraient les jumeaux, parmi les suffrages exprimés',
    aLieu: 'a lieu dans {p} des scénarios',
    chance: '{nom} l’emporte dans {p} des cas',
    aria: '{a} {pa} %, {b} {pb} %',
    retrait: 'Blanc, nul ou abstention : {p}',
  },
  central: {
    titre: 'Le scénario le plus probable',
    legende: 'candidature par candidature ; premier tour projeté depuis la {vague}',
    sansVague: 'candidature par candidature ; son premier tour se projette à la prochaine vague',
  },
  duels: {
    titre: 'Les seconds tours possibles',
    legende: 'sur toutes les combinaisons de candidatures, chacune pesée par sa probabilité',
    face: '{a} face à {b}',
  },
  jumeaux: {
    titre: 'Ce que disent les jumeaux seuls',
    legende: 'Chaque jumeau a noté chaque candidat ; leurs préférences sont les leurs. Seule leur façon de trancher entre les candidats qu’ils apprécient est réglée sur les sondages, jamais le niveau d’un candidat.',
    ecart: 'À {n} points en moyenne des sondages, sur les candidats qu’ils testent.',
  },
  variations: {
    titre: 'Ce que change chaque candidature possible',
    legende: 'face au scénario le plus probable',
    si: 'Si {nom} se présente',
    siPas: 'Si {nom} ne se présente pas',
    ferait: '{nom} ferait {p} au premier tour.',
    feraitCourt: '{p} au premier tour',
    nonMesureCourt: 'aucun jumeau ne le cite encore',
    points: '{n} pt',
    secondChange: 'Le second tour change : {a} et {b}.',
    secondIdem: 'Le second tour ne change pas.',
    nonMesure: 'Aucun jumeau ne cite {nom}, ni pour lui-même ni autour de lui : il ne pèse pas encore dans ce panel.',
  },
  scenarios: {
    titre: 'Les scénarios les plus probables',
    base: 'projetés depuis la {vague}',
    sansVague: 'leur premier tour se projette à la prochaine vague',
    central: 'Le scénario central',
    numero: 'Scénario {n}',
    avec: 'Avec',
    sans: 'Sans',
    declaresSeuls: 'Les seuls candidats déclarés',
    second: 'Au second tour : {a} et {b}',
    aMesurer: 'Ce scénario se projettera à la prochaine vague, qui proposera aussi ses candidats.',
  },
}
